import React from "react";
import { motion } from "framer-motion";
import CTAButton from "./CTAButton";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function VideoSection() {
  const { content } = useSiteContent();
  return (
    <section className="py-24 lg:py-32" data-testid="video-section">
      <div className="container">
        <div className="max-w-3xl mb-12">
          <div className="eyebrow mb-4"><span className="kicker-line" />Estratégia comprovada</div>
          <h2 className="text-4xl md:text-5xl font-display font-light">
            {content.video_title} <span className="italic text-gold-gradient">{content.video_title_highlight}</span>{content.video_subtitle}
          </h2>
          <p className="text-muted-foreground mt-6 max-w-xl">{content.video_description}</p>
        </div>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="relative max-w-[400px] mx-auto">
          <div className="absolute -inset-6 blur-3xl opacity-20 rounded-full" style={{ background: "var(--gold-gradient)" }} />
          <video controls className="relative w-full aspect-[9/16] rounded-sm border border-primary/30 shadow-gold object-cover bg-black/20">
            <source src={content.video_src} type="video/mp4" />
          </video>
        </motion.div>
        <CTAButton centered />
      </div>
    </section>
  );
}
